import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AppDivider, AppSegment, AppImage } from 'client/ui-building-blocks'
import { FormName } from 'client/utils'
import { getAssetUrl } from 'client/services'
import { usePageStateContext } from 'client/hooks'

import LoginForm from './LoginForm/login-form'
import RegisterForm from './RegisterForm/register-form'
import RecoverPasswordForm from './RecoverPasswordForm/recover-password-form'

const AuthPage = () => {
  const { t } = useTranslation()

  const { authForm } = usePageStateContext()

  const APP_SEGMENT_CONFIG = useMemo(() => {
    return {
      [FormName.AuthenticationForm]: {
        text: t('authPage.login.header'),
        iconProps: { name: 'USER_CIRCLE' },
      },
      [FormName.RegistrationForm]: {
        text: t('authPage.register.header'),
        iconProps: { name: 'USER_PLUS' },
        marginBottom: 'small',
      },
      [FormName.RecoverPasswordForm]: {
        text: t('authPage.recover.header'),
        iconProps: { name: 'UNLOCK' },
      },
    }
  }, [t])

  return (
    <AppSegment maxWidth="small" centered headerProps={APP_SEGMENT_CONFIG[authForm]}>
      {authForm !== FormName.RegistrationForm && (
        <>
          <AppImage
            src={getAssetUrl('cat-bot-small.jpg')}
            width="250px"
            height="250px"
            alt="logo"
            centered
            rounded
          />
          <AppDivider />
          <AppDivider />
        </>
      )}
      {authForm == FormName.AuthenticationForm && <LoginForm />}
      {authForm === FormName.RegistrationForm && <RegisterForm />}
      {authForm === FormName.RecoverPasswordForm && <RecoverPasswordForm />}
    </AppSegment>
  )
}

export default AuthPage
